import Topnav from './Topnav';


Topnav.install = function(Vue) {
  Vue.component(Topnav.name, Topnav);
};

export default Topnav;
